"use client";
import { useQuery } from "@tanstack/react-query";

export interface ProfileData {
  id: string;
  email: string;
  full_name: string | null;
  username: string | null;
  avatar_url: string | null;
  role: string;
}

interface ProfileResponse {
  profile: ProfileData | null;
  userId: string | null;
  error?: string;
}

async function fetchProfile(): Promise<ProfileResponse> {
  const res = await fetch("/api/auth/profile", { credentials: "include" });
  return res.json();
}

export function useProfile() {
  return useQuery({
    queryKey: ["profile"],
    queryFn: fetchProfile,
    staleTime: 30_000,
  });
}
